import Model from "~/models/_Model";

export default class System extends Model {
  resource() {
    return "systems";
  }
}
